import React from "react";

export default function GmailComposeStyles({ replyToMessageId, forwardEmail }) {
  return (
    <div>
      <style>
        {`
        .compose-modal-width {
          max-width: 70vw;
          margin-right: auto;
        }
        .compose-field-group {
          margin-bottom: 12px;
        }
        .compose-field-label {
          display: block;
          font-size: 0.85rem;
          font-weight: 600;
          color: #475569;
          margin-bottom: 4px;
        }
        .compose-line-field {
          margin-bottom: 10px;
        }
        .compose-line-input {
          width: 100%;
          border: 0;
          border-bottom: 1px solid #e2e8f0;
          padding: 6px 4px;
          font-size: 0.95rem;
          color: #1f2937;
          background-color: transparent;
        }
        .compose-line-input:focus {
          outline: none;
          border-bottom-color: #2563eb;
        }
        .compose-field-input,
        .compose-field-select {
          width: 100%;
          border: 1px solid #cbd5f5;
          border-radius: 6px;
          padding: 6px 10px;
          font-size: 0.95rem;
          color: #1f2937;
          background-color: #fff;
        }
        .compose-field-input:focus,
        .compose-field-select:focus {
          border-color: #2563eb;
          box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2);
          outline: none;
        }
        .compose-attachments-list {
          margin-top: 6px;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .compose-attachment-item {
          font-size: 0.85rem;
          color: #475569;
          padding: 4px 8px;
          border-radius: 4px;
          background-color: #f1f5f9;
        }
        .compose-forward-attachments {
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          padding: 8px 10px;
          background-color: #f8fafc;
          max-height: 150px;
          overflow-y: auto;
        }
        .compose-forward-option {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 0.85rem;
          color: #334155;
          margin-bottom: 6px;
        }
        .compose-forward-option:last-child {
          margin-bottom: 0;
        }
        .compose-forward-option input {
          margin: 0;
        }
        .compose-forward-chip {
          font-size: 0.85rem;
          color: #334155;
          margin-bottom: 6px;
        }
        .compose-editor-shell {
          border: 1px solid lightgray;
          border-radius: 8px;
          height: ${replyToMessageId || forwardEmail ? "25vh" : "45vh"};
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }
        .compose-editor-toolbar {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          padding: 8px 10px;
          border-top: 1px solid #e2e8f0;
          background-color: #f8fafc;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          align-items: center;
        }
        .compose-toolbar-btn {
          border: 1px solid transparent;
          background: transparent;
          padding: 2px 8px;
          font-weight: 600;
          cursor: pointer;
          border-radius: 4px;
          color: #1f2937;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
        }
        .compose-toolbar-btn.active {
          border-color: #2563eb;
          color: #2563eb;
          background-color: #e0ecff;
        }
        .compose-toolbar-btn:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }
        .compose-toolbar-select {
          border: 1px solid #cbd5f5;
          border-radius: 9999px;
          background: #fff;
          padding: 2px 10px;
          font-size: 0.9rem;
          color: #1f2937;
          height: 28px;
        }
        .compose-toolbar-select:focus {
          outline: 2px solid #2563eb;
          outline-offset: 1px;
        }
        .compose-color-palette {
          position: relative;
        }
        .compose-color-button {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 2px 6px;
          border-radius: 9999px;
          border: 1px solid #cbd5f5;
          background: #fff;
          cursor: pointer;
          font-weight: 600;
          color: #1f2937;
        }
        .compose-color-button:focus {
          outline: 2px solid #2563eb;
          outline-offset: 1px;
        }
        .compose-color-label {
          font-size: 0.9rem;
        }
        .compose-emoji-picker {
          position: relative;
        }
        .compose-emoji-panel {
          position: absolute;
          top: calc(100% + 6px);
          left: 0;
          z-index: 15;
          background: #fff;
          border: 1px solid #cbd5f5;
          border-radius: 8px;
          padding: 6px;
          display: grid;
          grid-template-columns: repeat(6, 1fr);
          gap: 4px;
          box-shadow: 0 12px 25px rgba(15, 23, 42, 0.18);
          min-width: 180px;
        }
        .compose-emoji-button {
          border: none;
          background: transparent;
          font-size: 1.1rem;
          cursor: pointer;
          padding: 4px;
          border-radius: 4px;
        }
        .compose-emoji-button:hover {
          background-color: #eff6ff;
        }
        .compose-color-indicator {
          width: 18px;
          height: 8px;
          border-radius: 9999px;
          border: 1px solid #cbd5f5;
        }
        .compose-color-caret {
          font-size: 0.75rem;
          color: #475569;
        }
        .compose-color-panel {
          position: absolute;
          top: calc(100% + 6px);
          left: 0;
          z-index: 10;
          background: #fff;
          padding: 8px;
          border-radius: 8px;
          border: 1px solid #cbd5f5;
          display: flex;
          flex-direction: column;
          gap: 4px;
          box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);
        }
        .compose-color-row {
          display: flex;
          gap: 2px;
        }
        .compose-color-swatch {
          width: 18px;
          height: 18px;
          border: 1px solid rgba(15, 23, 42, 0.15);
          border-radius: 2px;
          padding: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #fff;
          font-size: 0.75rem;
          position: relative;
        }
        .compose-color-swatch.transparent {
          background-image: linear-gradient(135deg, #e2e8f0 25%, transparent 25%, transparent 50%, #e2e8f0 50%, #e2e8f0 75%, transparent 75%, transparent);
          background-size: 8px 8px;
          background-color: #fff;
        }
        .compose-color-swatch.selected {
          border-color: #2563eb;
        }
        .compose-color-swatch span {
          font-weight: 700;
          color: #fff;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
        }
        .compose-color-swatch.transparent span {
          color: #2563eb;
        }
        .compose-toolbar-divider {
          width: 1px;
          background-color: #cbd5f5;
          align-self: stretch;
          margin: 0 2px;
        }
        .compose-editor-container {
          position: relative;
          flex: 1;
          min-height: 140px;
        }
        .compose-editor-area {
          padding: 12px;
          height: 100%;
          overflow-y: auto;
          outline: none;
          font-size: 0.95rem;
        }
        .compose-editor-placeholder {
          position: absolute;
          top: 12px;
          left: 12px;
          color: #94a3b8;
          pointer-events: none;
        }
        .compose-editor-paragraph {
          margin: 0;
          padding: 0;
          line-height: 1.4;
        }
        .compose-editor-area .compose-editor-underline,
        .compose-editor-underline {
          text-decoration-line: underline;
          text-decoration-thickness: 1.5px;
          text-underline-offset: 2px;
        }
        .compose-editor-area .compose-editor-underline-strike,
        .compose-editor-underline-strike {
          text-decoration-line: underline line-through;
          text-decoration-thickness: 1.5px;
          text-underline-offset: 2px;
        }
        .compose-editor-link {
          color: #1d4ed8;
          text-decoration: underline;
          text-underline-offset: 3px;
          position: relative;
        }
        .compose-editor-link:hover::after {
          content: attr(href);
          position: absolute;
          bottom: -32px;
          left: 0;
          background: #0f172a;
          color: #fff;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 0.75rem;
          white-space: nowrap;
          box-shadow: 0 10px 20px rgba(15, 23, 42, 0.25);
        }
        .compose-editor-link:hover::before {
          content: "";
          position: absolute;
          bottom: -6px;
          left: 8px;
          border-width: 6px 6px 0 6px;
          border-style: solid;
          border-color: #0f172a transparent transparent transparent;
        }
        .compose-forward-preview {
          border: 1px solid #e2e8f0;
          border-radius: 10px;
          padding: 12px;
          background-color: #fdfdfd;
          margin-bottom: 14px;
        }
        .compose-forward-section + .compose-forward-section {
          margin-top: 12px;
        }
        .compose-forward-label {
          font-size: 0.85rem;
          font-weight: 600;
          color: #475569;
          margin-bottom: 6px;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .compose-forward-header-box {
          margin: 0;
          background: #0f172a;
          color: #f8fafc;
          padding: 8px 10px;
          border-radius: 6px;
          font-size: 0.85rem;
          white-space: pre-wrap;
          max-height: 160px;
          overflow-y: auto;
        }
        .compose-forward-iframe {
          width: 100%;
          border: 0;
          border-radius: 8px;
          min-height: 260px;
          background: #fff;
          box-shadow: inset 0 0 0 1px #e2e8f0;
        }
        .compose-forward-hint {
          font-size: 0.75rem;
          color: #64748b;
          margin-top: 6px;
        }
      `}
      </style>
    </div>
  );
}
